<template>
  <div v-if="customer || contactPerson" class="table-customer-data">
    <template v-if="customer">
      <CustomerData :user="customer" @change-customer-status="changeCustomerStatus($event, 'customer')"/>

      <div class="table-small-text p-d-flex p-ai-center p-flex-wrap">

          <div v-if="!contactPerson && showPhoneNumber && customerPhoneNumber"
               class="p-d-flex p-ai-center"
               v-tooltip.right="customerPhoneNumber">
            <span class="p-mr-2">{{ customerPhoneNumber }}</span>
          </div>

          <div class="p-d-flex p-ai-center">
            <div class="p-d-flex p-ai-center p-mr-2">
              <i class="ti-hummer"/>
              <div class="medium-bold-text">{{ customer.orders_count ?? 0 }}</div>
            </div>
            <div class="p-d-flex p-ai-center p-mr-2">
              <i class="ti-clipboard" style="margin-right: 2px"/>
              <div class="medium-bold-text">{{ customer.offers_count ?? 0 }}</div>
            </div>
            <div class="p-d-flex p-ai-center p-mr-2">
              <i style="margin-right: 3px" :class="$store.getters.isForkliftTenant ? 'ti-truck' : 'ti-car'"/>
              <div class="medium-bold-text">{{ customer.cars_count ?? 0 }}</div>
            </div>
          </div>

         <div v-if="showPhoneNumber && contactPersonPhoneNumber"
              class="p-d-flex p-ai-center"
              v-tooltip.right="contactPersonPhoneNumber">
          <span class="p-mr-2">{{ contactPersonPhoneNumber }}</span>
        </div>
      </div>
    </template>

    <div v-if="contactPerson" class="contact-person-wrapper">
      <CustomerData :user="contactPerson" @change-customer-status="changeCustomerStatus($event, 'contactPerson')"/>
    </div>
  </div>

  <i v-else class="ti-minus"/>
</template>

<script>
import CustomerData from "@/components/CustomerData.vue";

export default {
  name: 'TableCustomerData',
  emits: ['change-customer-status'],
  components: { CustomerData },
  props: {
    customer: {
      type: Object,
      default: null,
    },
    contactPerson: {
      type: Object,
      default: null,
    },
    showPhoneNumber: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    customerPhoneNumber() {
      return this.customer && this.customer.phone_code && this.customer.phone_number ? `+${this.customer.phone_code} ${this.customer.phone_number}` : null
    },

    contactPersonPhoneNumber() {
      return this.contactPerson && this.contactPerson.phone_code && this.contactPerson.phone_number ? `+${this.contactPerson.phone_code} ${this.contactPerson.phone_number}` : null
    },
  },
  methods: {
    changeCustomerStatus(newStatus, type = 'customer') {
      const userId = type === 'contactPerson'
          ? this.contactPerson?.id
          : this.customer?.id

      if (!userId) return

      this.$emit('change-customer-status', {
        newStatus,
        userId,
        type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-customer-data {
  min-width: 180px;
}
.contact-person-wrapper {
  margin-top: 4px;
}
</style>